<script lang="ts" setup>
defineProps<{ message?: string }>();
</script>

<template>
  <p class="error-message mt-2 text-sm text-red-600">
    <slot>{{ message }}</slot>
  </p>
</template>
